import React from 'react';

import TextDetail from './TextDetail/TextDetail';

export default (props: any) => <TextDetail {...props} photo={true} />;
